<template>
<!-- Make Navbar fixed, transparent, and disappear on scroll
https://www.w3schools.com/howto/howto_js_navbar_hide_scroll.asp -->
  <div>
    <div class=""><router-link to="/home" class="w-40-ns w-80 black link db h3 f3-ns f4 b1 left b ttu ph4-ns pl2 logo pb4-ns dim">United Builders Group</router-link></div>
    <label class="toggle dim pa4">
      <input
        type="checkbox" id="checkbox" 
        @click="showMenu = !showMenu">
      <div>
        <div>
          <span />
          <span />
        </div>
        <svg>
          <path d="M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22" />
        </svg>
        <svg>
          <path d="M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22" />
        </svg>
      </div>
    </label>
    <transition name="fade">
      <div
        v-if="showMenu"
        class="nav-container w-100 dt f2"
      >
        <div class="fw1 f4 w-100 tc white title">{{ title }}</div>
        <div class="nav-mobile dtc v-mid">
          <router-link
            v-for="(tab, index) in tabs"
            :key="index"
            class="link white tc center"
            :to="tab.path"
          >
            <div class="h3 dim dt w-100">
              <div
                v-if="showMenu"
                class="name dtc v-mid fw1" :class="{ active: isActive(tab) }"
              >
                {{ tab.name }}
              </div>
            </div>
          </router-link>
          <div class="white center tc link social mt5">
            <div class="f3">Follow us on </div>
            <a href="https://www.instagram.com/unitedbuildersgroup" target="_" class="dib insta pa3 dim">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
            <a href="https://www.facebook.com/unitedbuildersgroupnyc" target="_" class="dib facebook pa3 dim">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      showMenu: false,
      title: 'United Builders Group',
      tabs: [
        { name: 'Home', path: '/home' },
        { name: 'About', path: '/about' },
        { name: 'Portfolio', path: '/portfolio' },
        { name: 'Contact', path: '/contact' },
        //{ name: 'Instagram', path: 'http://instagram.com' }
      ],
    };
  },
  watch:{
    $route (to, from){
      if(this.showMenu) {
        this.showMenu = false
        document.getElementById('checkbox').checked = !document.getElementById('checkbox').checked
      }
    }
  }, 
  methods: {
    isActive: function (tab) {
      return tab.path === this.$router.currentRoute.path
    }
  }
};
</script>

<style scoped>
.social svg {
  -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
          filter: invert(100%);
}
.logo {
  padding-top: 1.6rem;
  padding-bottom: 3.5rem;
  font-weight: 500;
  /* transition: all .3s ease-in; */
}
.logo:hover {
  /* letter-spacing: .2em; */
  cursor: pointer;
}
.nav-container {
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  background-color: rgb(0,0,0); /* Black fallback color */
  background-color: rgba(0,0,0, 0.9); /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.7s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
}
.nav-mobile {
    table-layout: fixed;
}
.dtr {
    display: table-row;
    width: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.title {
  font-family: josefin-sans, sans-serif;
  text-transform: uppercase;
  letter-spacing: .1em;
  position: absolute;
  bottom: 5%;
  /* top: 20%; */
}
.active {
  color: darkgray;
  /* font-style: italic; */
}

/* Hamburger Menu Styling */
.toggle {
  display: block;
  cursor: pointer;
  position: absolute;
  top: 0%;
  right: 0%;
  z-index: 2; /* Sit on top */
}
.toggle input {
  display: none;
}
.toggle input + div {
  width: 20px;
  height: 14px;
  position: relative;
}
.toggle input + div div {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  transition: -webkit-transform .5s ease;
  transition: transform .5s ease;
  transition: transform .5s ease, -webkit-transform .5s ease;
}
.toggle input + div div span {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
}
.toggle input + div div span:first-child {
  top: 0;
}
.toggle input + div div span:first-child:before, .toggle input + div div span:first-child:after {
  top: 0;
}
.toggle input + div div span:last-child {
  bottom: 0;
}
.toggle input + div div span:last-child:before, .toggle input + div div span:last-child:after {
  bottom: 0;
}
.toggle input + div div span:before, .toggle input + div div span:after {
  content: '';
  display: block;
  width: 47%;
  height: 2px;
  border-radius: 1px;
  background: #000;
  position: absolute;
  -webkit-backface-visibility: hidden;
  transition: border-radius .3s ease, background .4s ease, -webkit-transform .5s ease;
  transition: transform .5s ease, border-radius .3s ease, background .4s ease;
  transition: transform .5s ease, border-radius .3s ease, background .4s ease, -webkit-transform .5s ease;
}
.toggle input + div div span:before {
  left: 0;
  -webkit-transform-origin: 0 50%;
          transform-origin: 0 50%;
  -webkit-transform: translate(1px, 0) scaleX(1.1);
          transform: translate(1px, 0) scaleX(1.1);
}
.toggle input + div div span:after {
  right: 0;
  -webkit-transform-origin: 100% 50%;
          transform-origin: 100% 50%;
  -webkit-transform: translate(-1px, 0) scaleX(1.1);
          transform: translate(-1px, 0) scaleX(1.1);
}
.toggle input + div svg {
  display: block;
  fill: none;
  stroke: #000;
  stroke-width: 2px;
  width: 44px;
  height: 44px;
  stroke-linecap: round;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -22px 0 0 -22px;
  stroke-dasharray: 0 82.801 8 82.801;
  stroke-dashoffset: 82.801;
  -webkit-transform-origin: 50% 50%;
          transform-origin: 50% 50%;
  -webkit-backface-visibility: hidden;
  -webkit-transform: scale(1);
          transform: scale(1);
  transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, stroke .4s ease, -webkit-transform .5s ease;
  transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, transform .5s ease, stroke .4s ease;
  transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, transform .5s ease, stroke .4s ease, -webkit-transform .5s ease;
}
.toggle input + div svg:nth-child(3) {
  -webkit-transform: rotate(180deg) scale(1);
          transform: rotate(180deg) scale(1);
}
.toggle input:checked + div div {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}
.toggle input:checked + div div span:before, .toggle input:checked + div div span:after {
  background: #fff;
}
.toggle input:checked + div div span:first-child:before {
  -webkit-transform: rotate(45deg) translate(2.2px, -3px) scaleX(1.05);
          transform: rotate(45deg) translate(2.2px, -3px) scaleX(1.05);
}
.toggle input:checked + div div span:first-child:after {
  -webkit-transform: rotate(-45deg) translate(-2.2px, -3px) scaleX(1.05);
          transform: rotate(-45deg) translate(-2.2px, -3px) scaleX(1.05);
}
.toggle input:checked + div div span:last-child:before {
  -webkit-transform: rotate(-45deg) translate(2.2px, 3px) scaleX(1.05);
          transform: rotate(-45deg) translate(2.2px, 3px) scaleX(1.05);
}
.toggle input:checked + div div span:last-child:after {
  -webkit-transform: rotate(45deg) translate(-2.2px, 3px) scaleX(1.05);
          transform: rotate(45deg) translate(-2.2px, 3px) scaleX(1.05);
}
.toggle input:checked + div svg {
  stroke-dashoffset: 62;
  stroke-dasharray: 0 82.801 62 82.801;
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
  stroke: #fff;
}
.toggle input:checked + div svg:nth-child(3) {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

html {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

* {
  box-sizing: inherit;
}
*:before, *:after {
  box-sizing: inherit;
}
</style>
